import { FormField, Numeric } from "@rothoblaas/design-system";
import { Controller, useFormContext } from "react-hook-form";
import useI18n from "../../../../../hooks/useTranslations";
import type { LockCalculatorFormValues } from "../../model/form";
import styles from "../../LockCalculator.module.css";

type Props = { readOnly: boolean; onOpenHelp?: (text: string, image?: string) => void };

/** Form input only: it never derives BOM quantities in the client. */
export const BomConnectionCountField = ({ readOnly, onOpenHelp }: Props) => {
  const { control } = useFormContext<LockCalculatorFormValues>();
  const { translation: t } = useI18n();

  return (
    <div className={styles.bomConnectionCount}>
      <Controller
        name="bom.connectionCount"
        control={control}
        render={({ field }) => (
          <FormField
            label={t.lockCalculatorModule?.configuration?.connectionCount}
            showHelp={{
              tooltip: t.lockCalculatorModule?.helpTexts?.connectionCount,
              onOpen: () => onOpenHelp?.(t.lockCalculatorModule?.helpTexts?.connectionCount ?? ""),
            }}
          >
            {({ labelId, isInvalid }) => (
              <Numeric
                id={labelId}
                value={field.value}
                decimalScale={0}
                suffix={t.common.unitPcs}
                isInvalid={isInvalid}
                allowNegative={false}
                disabled={readOnly}
                onValueChange={(value) => field.onChange(value != null ? Math.trunc(value) : null)}
              />
            )}
          </FormField>
        )}
      />
    </div>
  );
};
